import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addUserStart, fetchUsersStart } from '../../redux/UserInfo/userInfo.actions';
import Modal from '../../components/Modal';
import FormInput from '../../components/forms/FormInput';
import FormSelect from '../../components/forms/FormSelect';
import Button from '../../components/forms/Button';
import './styles.scss';

const mapState = ({ usersData }) => ({
  usersInfos: usersData.usersInfos
});


const Dashboard = props => {
  const { usersInfos } = useSelector(mapState);
  const dispatch = useDispatch();
  const [hideModal, setHideModal] = useState(true);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [social, setSocial] = useState('');

  useEffect(() => {


  }, []);

  const toggleModal = () => setHideModal(!hideModal);

  const configModal = {
    hideModal,
    toggleModal
  };

  useEffect(() => {
    dispatch(
      fetchUsersStart()
    );

  }, []);

  const resetForm = () => {
    setHideModal(true);
    setName('');
    setPhone('');
    setAddress('');
    setSocial('');
  };

  const handleSubmit = e => {
    e.preventDefault();

    dispatch(
      addUserStart({
        name,
        phone,
        address,
        social
      })
    );
    
    resetForm();
  };


  return (
    <div className="admin">

      <div className="callToActions">
        <ul>
          <li>
            <Button onClick={() => toggleModal()}>
              Add Account
            </Button>
          </li>
        </ul>
      </div>

      <Modal {...configModal}>
        <div className="addNewProductForm">
          <form onSubmit={handleSubmit}>

            <h2>
              User Info
            </h2>

            <FormInput
              label="Name"
              type="text"
              value={name}
              handleChange={e => setName(e.target.value)}
            />

            <FormInput
              label="Phone number"
              type="text"
              value={phone}
              handleChange={e => setPhone(e.target.value)}
            />

            <FormInput
              label="Address"
              type="text"
              value={address}
              handleChange={e => setAddress(e.target.value)}
            />

            <FormInput
              label="Social Media"
              type="text"
              value={social}
              handleChange={e => setSocial(e.target.value)}
            />



            <br />

            <Button type="submit">
              Submit
            </Button>

          </form>
        </div>
      </Modal>

      <div className="manageProducts">

        <table border="0" cellPadding="0" cellSpacing="0">
          <tbody>
            <tr>
              <th>
                <h2>
                  Seller
                </h2>
              </th>
            </tr>
            <tr>
              <td>
                <table className="results" border="0" cellPadding="10" cellSpacing="0">
                  <tbody>
                  {usersInfos.map((userInfo, index) => {
                      const {
                        name,
                        phone,
                        address,
                        social
                      } = userInfo;

                      return (
                        <tr>
                          <td>
                            {name}
                          </td>
                          <td>
                            {phone}
                          </td>
                          <td>
                            {address}
                          </td>
                          <td>
                            <a href={{social}}>Social Media Link</a>
                           
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>

              </td>
            </tr>

          </tbody>
        </table>

      </div>

    </div>
  );
}


export default Dashboard;